module.exports = __webpack_public_path__ + "assets/img/wb_qrcode.698e31af.png";